module.exports = __webpack_public_path__ + "static/dolomites-c77d240e2507a51f32330e9f059b7fa5.jpg";